<template>
  <section
    id="pricing-plan"
  >
    <!-- title text and switch button -->
     
    
    <!-- buttons -->
    <b-button
    v-ripple.400="'rgba(40, 199, 111, 0.15)'"
    block
    class="mt-2"
    variant="primary"
    @click="openEdit()"
    >
    Düzenle
    </b-button>
    

    <!-- Paket Fiyatları -->
    <plans :plans="plans" v-if="plans.length>0"></plans>
    
    <!--/ pricing plan cards -->

    <!-- pricing free trial -->
    <div class="pricing-free-trial">
      <b-row>
        <b-col
          lg="10"
          offset-lg="3"
          class="mx-auto"
        >
          <div class="pricing-trial-content d-flex justify-content-between">
            <div class="text-center text-md-left mt-3">
              <h3 class="text-primary">
                Still not convinced? Start with a 14-day FREE trial!
              </h3>
              <h5>You will get full access to with all the features for 14 days.</h5>
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mt-2 mt-lg-3"
              >
                Start 14-day FREE trial
              </b-button>
            </div>

            <!-- images -->
            <b-img
              fluid
              :src="require('@/assets/images/illustration/pricing-Illustration.svg')"
              class="pricing-trial-img"
              alt="svg img"
            />
            <!--/ images -->
          </div>
        </b-col>
      </b-row>
    </div>
    <!--/ pricing free trial -->
    <package-edit
        :featureData="featureData"
        :editablePlans="plans"
        @update-plans="getPlans"
        :is-show-modal.sync="showModal"
    />
  </section>
</template>

<script>
import {
  BFormCheckbox, BRow, BCol, BCard, BImg, BCardText, BButton, BBadge,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import PackageEdit from './PackageEdit.vue'
import Plans from './Plans.vue'
/* eslint-disable global-require */
export default {
  components: {
    BFormCheckbox,
    BButton,
    BCardText,
    BRow,
    BCol,
    BCard,
    BBadge,
    BImg,
    PackageEdit,
    Plans
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      showModal:false,
      plans: [],
      featureData:[],
    }
  },
  created() {
    this.getPlans();
  },
  computed: {
  },
  methods: {
    getPlans() {
        this.$http.get('/manage/packages').then(response => { 
            this.plans = response.data.data
        })
    },
    openEdit() {
        this.showModal = true
        if(this.featureData.length>0){
            return
        }
        this.$http.get('/manage/package-categories').then(res => {
            this.featureData = res.data.data // API'den dönen veri
        })
    },
  },
}
/* eslint-disable global-require */
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-pricing.scss';
</style>
